import { useEffect, useRef } from "react"
import Chart from "chart.js/auto"
import { roundUp } from "../../../helper/utils/formatting"

interface MixedChartProps {
  chartName?: string
  labels?: any[]
  xAxisLabel?: string
  xAxisUnit?: string
  yAxisLabel?: string
  yAxisUnit?: string
  chartData: {
    labels: string[]
    datasets: {
      label: string
      data: number[]
      backgroundColor?: string
      borderWidth?: number
      borderColor?: string
      type?: any
      yAxisID?: string
    }[]
  }
  scales?: {
    isMultiAxis?: boolean
    axes?: {
      id: string
      type?: string
      position?: string
      axisUnit?: string
      offset?: boolean
      stackWeight?: number
      [key: string]: any
      label?: {
        display?: boolean
        text?: string
        position?: string
        color?: string
        align?: string
      }
    }[]
  }
}

const MixedChart = ({
  chartName,
  labels,
  // dataSets,
  chartData,
  xAxisLabel,
  yAxisLabel,
  yAxisUnit,
  scales,
  xAxisUnit,
}: MixedChartProps) => {
  const chartRef = useRef<any>(null)
  const chartInstance = useRef<any>(null)
  // to handle the responsiveness of the chart

  useEffect(() => {
    const handleResize = () => {
      if (chartInstance.current) {
        chartInstance.current.resize()
      }
    }

    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const createScales = () => {
    const scale: any = {}

    if (scales) {
      if (scales.isMultiAxis) {
        scales?.axes?.forEach((axis: any) => {
          scale[axis.id] = {
            type: axis.type,
            stack: "stack",
            position: axis.position,
            stackWeight: axis.stackWeight,
            offset: axis.offset,
            title: {
              display: axis.label.display,
              text: axis.label.text,
              position: axis.label.position,
              color: axis.label.color,
              align: axis.label.align,
            },
            ticks: {
              callback: (value: string) =>
                axis.axisUnit === "#"
                  ? ""
                  : axis.axisUnit === "$"
                  ? axis.axisUnit + parseFloat(value).toLocaleString()
                  : value + (axis.axisUnit || ""),
            },
          }
        })
      } else {
        scales?.axes?.forEach((axis: any) => {
          scale[axis.id] = {
            type: axis.type,
            position: axis.position,
            title: {
              display: axis.label.display,
              text: axis.label.text,
              position: axis.label.position,
              color: axis.label.color,
              align: axis.label.align,
              // ...(axis.stackWeight ? { stackWeight: axis.stackWeight } : {}),
              // ...(axis.offset ? { offset: axis.offset } : {}),
            },
            ticks: {
              callback: (value: string) =>
                axis.axisUnit === "#"
                  ? value
                  : axis.axisUnit === "$"
                  ? axis.axisUnit + parseFloat(value).toLocaleString()
                  : value + (axis.axisUnit || ""),
            },
          }
        })
      }
    } else {
      scale.y = {
        type: "linear",
        position: "left",
        title: {
          display: true,
          text: yAxisLabel,
        },
        ticks: {
          callback: (value: string) => value + (yAxisUnit || ""),
        },
      }

      scale.x = {
        title: {
          display: true,
          text: xAxisLabel,
        },
        ticks: {
          // callback: (value: string, index: number, ticks: any) => {
          //   return ticks[index]
          // },
        },
      }
    }

    return scale
  }
  const scale1 = createScales()

  useEffect(() => {
    if (!chartInstance.current) {
      const ctx = chartRef.current?.getContext("2d")
      if (ctx) {
        // const formattedDataSets = chartData.datasets.map(
        //   ({ label, data, ...rest }) => ({
        //     label,
        //     // data: data.map((value) => parseFloat(value)), // Convert data to numbers
        //     ...rest,
        //   }),
        // )

        const data: any = (chartInstance.current = new Chart(ctx, {
          type: "line",
          data: chartData,
          options: {
            maintainAspectRatio: true,
            responsive: true,
            // interaction: {
            //   mode: "index",
            //   intersect: false,
            // },
            // stacked: false,
            plugins: {
              tooltip: {
                callbacks: {
                  // title: (xDatapoint: any) => {
                  //   console.log("xDatapoint", xDatapoint)
                  //   return roundUp(
                  //     xDatapoint[0]?.raw,
                  //     xDatapoint[0]?.dataset?.yAxisID,
                  //   )
                  // },
                  label: (yDatapoint: any) => {
                    return (
                      yDatapoint?.dataset?.label +
                      ": " +
                      roundUp(yDatapoint?.raw, yDatapoint?.dataset?.yAxisID)
                    )
                  },
                },
              },

              title: {
                display: chartName ? true : false,
                padding: {
                  top: 10,
                  // bottom: -25,
                },
                text: chartName,
                position: "top",
                align: "start",
              },
              legend: {
                position: "top",
                align: "end",
                reverse: true,

                labels: {
                  usePointStyle: true,
                  pointStyle: "rect",
                },
              },
            },
            scales: scale1,
          },
        }))
      }
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy()
        chartInstance.current = null
      }
    }
  }, [labels, chartData, xAxisLabel, yAxisLabel, yAxisUnit, scales])

  return <canvas ref={chartRef}></canvas>
}

MixedChart.defaultProps = {
  dataSets: [
    {
      type: "bar",
      label: "Default",
      data: [],
      backgroundColor: "rgba(255, 99, 132, 0.5)",
      borderWidth: 1,
    },
  ],
}

export default MixedChart
